import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { getDossierFileSummaryByFileId } from '../../data/dossierMock';
import type { FileSummaryNewUi } from './FileSummaryNewUi.types';

interface ClaimIgnoreDateRulesChecking {
  ignoreDateRulesChecking?: boolean;
}

export const useGetFileSummaryNewUi = () => {
  const { fileId } = useParams() as { fileId: string };

  const data = useMemo(() => getDossierFileSummaryByFileId(fileId), [fileId]);

  return { isLoading: false, data };
};

export const useGetFileSummaryNewUiWithClaim = (claimId?: string) => {
  const { fileId } = useParams() as { fileId: string };

  const data = useMemo(() => {
    const file = getDossierFileSummaryByFileId(fileId);

    if (!file || !claimId) {
      return undefined;
    }

    return {
      file,
      claim: {
        ignoreDateRulesChecking: false,
      } satisfies ClaimIgnoreDateRulesChecking,
    };
  }, [claimId, fileId]);

  return { isLoading: false, data };
};

export type { FileSummaryNewUi };
